export function HelpShortcutsIntroContent() {
  return (
    <div class="help-copy">
      <p>
        Hold <kbd class="shortcut-key help-inline-key">Alt</kbd> briefly to reveal shortcut hints over the main app targets.
      </p>
      <p>
        Then either press the shown key directly, or release <kbd class="shortcut-key help-inline-key">Alt</kbd> and continue working normally.
      </p>
    </div>
  );
}
